<template>
  <div class="p-2">
    <div class="darkbox mt-0">
      <!-- call-to-action-colored -->
      <div
        class="ticket-card call-to-action m-1 mb-5"
        :class="{
          'call-to-action-dark': !ticket.checkInTime,
          'call-to-action-colored': ticket.checkInTime,
        }"
      >
        <h3 class="text-center text-white mb-5">{{ tenant.name }}</h3>

        <h1 style="font-size: 4em" class="text-white text-center ticket-name">
          <i
            class="fa-1x"
            :class="{
              'fas fa-people-arrows': esPresencial(ticket),
              'fa fa-phone': esTelefonico(ticket),
              'fa fa-tv': esVideoconf(ticket),
            }"
          ></i>
          {{ ticket.name }}
        </h1>

        <h2 class="text-center text-white servicepoint">
          {{ ticket.servicePoint.name }}
        </h2>

        <h3 class="text-center text-white mb-3 queuename" style="font-size: 80%">
          {{ ticket.queue.name }}
        </h3>
        <div style="min-height: 10em">
          <div class="my-2 text-white" v-if="esPresencial(ticket)">
            <h4
              v-html="
                $t('ticket.teesperamos', {
                  inicio: ticket.scheduledServiceDay,
                  fin: ticket.scheduledServiceHour,
                })
              "
            />

            <div class="my-2 subtext">
              <p
                v-html="
                  $t('ticket.teesperamosdesc', {
                    servicio: ticket.servicePoint.name,
                  })
                "
              />

              <div class="text-center mt-3">
                <i class="fa fa-map-marker"></i> {{ ticket.queue.addressLine1 }}
                <span v-if="ticket.queue.addressLine2">
                  - {{ ticket.queue.addressLine2 }}
                  <br />
                </span>
                {{ ticket.queue.zip }} {{ (ticket.queue.city || {}).name }}
              </div>
            </div>
            <br/>
          </div>

          <div class="my-2 text-white" v-if="esTelefonico(ticket)">
            <h4
              v-html="
                $t('ticket.tellamamos', {
                  inicio: ticket.scheduledServiceDay,
                  fin: ticket.scheduledServiceHour,
                })
              "
            />

            <div class="my-2 subtext">
              <p
                v-html="
                  $t('ticket.tellamamosdesc', {
                    visitorMobile: ticket.visitorMobile,
                    servicePoint: ticket.servicePoint.name,
                  })
                "
              />
            </div>
          </div>

          <div class="my-2 text-white" v-if="esVideoconf(ticket)">
            <h4
              v-html="
                $t('ticket.nosconectamos', {
                  inicio: ticket.scheduledServiceDay,
                  fin: ticket.scheduledServiceHour,
                })
              "
            />

            <div class="my-2 subtext">
              <p
                v-html="
                  $t('ticket.nosconectamosdesc', {
                    visitorMobile: ticket.visitorMobile,
                    servicePoint: ticket.servicePoint.name,
                  })
                "
              />
            </div>
          </div>
        </div>
        <p v-if="ticket.servicePoint.ticketLine1" class="text-center">
          {{ ticket.servicePoint.ticketLine1 }}
        </p>
        <p v-if="ticket.servicePoint.ticketLine2" class="text-center">
          {{ ticket.servicePoint.ticketLine2 }}
        </p>

        <div class="row" v-if="showButtons || true">

          <div class="col-2">
            <a
              class="btn btn-upvehu-blanco px-3 cancelar-cita-button"
              href="#"
              @click="cancelTicket(ticket)"
              v-if="!ticket.calledInTime"
            >
              <i class="fa fa-trash mr-1"></i>
            </a>
            <a v-else class="btn" style="opacity: 0">
              <br />
            </a>
          </div>
          <div class="col-10">
            <a
              class="btn btn-upvehu-blanco px-3"
              v-if="Utils.puedoIniciarVideoconferencia(ticket)"
              @click="Utils.iniciarVideoconferencia(ticket)"
            >
              <i class="fa fa-video mr-1"></i> Iniciar videoconferencia
            </a>
            <a
              class="btn btn-upvehu-blanco px-3"
              v-if="puedoHacerCheckin(ticket)"
              @click="hacerCheckin(ticket)"
            >
              <i class="fa fa-building mr-1"></i> Estoy en la oficina
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "@/services/Utils.js";
import APIPortal from "@/services/APIPortal.js";

export default {
  name: "Alerta",
  props: {
    ticket: Object,
    tenant: Object,
    showButtons: Boolean,
  },
  data: () => ({
    Utils
  }),
  methods: {

    async hacerCheckin() {
      this.ticket = (await APIPortal.checkinTicket(this.ticket.id)).data;
    },

    esPresencial(ticket) {
      return ticket.serviceChannel.id === Utils.ATTENCION_OFICINA;
    },

    esTelefonico(ticket) {
      return ticket.serviceChannel.id === Utils.ATTENCION_CALL_ME;
    },

    esVideoconf(ticket) {
      return ticket.serviceChannel.id === Utils.ATTENCION_TELECONF;
    },
    puedoHacerCheckin(t) {
      if ((t.serviceChannel || {}).id !== Utils.ATTENCION_OFICINA) return false;
      if (t.checkInTime) return false;

      return Utils.intervaloCortesiaAbierto(t);
    },
    async cancelTicket(ticket) {
      this.$swal({
        title: this.$t("ticket.cancelacioncitapreviatitle"),
        text: this.$t("ticket.cancelacioncitapreviadescr"),
        showCancelButton: true,
        confirmButtonColor: "#37474f",
        cancelButtonColor: "#000",
        confirmButtonText: this.$t("ticket.cancelacioncitapreviasi"),
        cancelButtonText: this.$t("ticket.cancelacioncitapreviano"),
      }).then(async (result) => {
        if (result.value) {
          await APIPortal.cancelTicket(ticket.id);

          this.$swal(
            this.$t("ticket.citacanceladatitle"),
            this.$t("ticket.citacanceladadescr"),
            "success"
          );

          this.$emit("cancelTicket", ticket);
        }
      });
    },
  },
};
</script>

<style scoped>
.checked-in-ticket {
  background-color: #591f1f;
}

.queuename {
  min-height: 4rem;
}

.servicepoint {
  min-height: 5rem;
}

.subtext {
  height: 6rem;
}

p {
  font-size: 80%;
}
</style>

